import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy "Writing and editing" lesson: the Statutes panel. Started from the
 * lesson page in a new tab; never auto-started. The first step asks the
 * officer to open a report and the Statutes tab, so it works with whatever
 * they have. It never clicks Identify Statutes for them.
 */
const tour: TutorialDefinition = {
  id: "statutes",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Statutes panel",
  description: "Find the charges your narrative supports and read the match strength.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "statutes",
  autoStart: false,
  steps: [
    {
      target: sel("caseListItem"),
      title: "Open a report",
      content: "Click any report that has a narrative.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("caseListItem"), event: "click" },
      hint: "Open a report to continue",
      spotlightClicks: true,
    },
    {
      target: `${sel("editorSidebarTabs")} button[title="Statutes"]`,
      waitFor: `${sel("editorSidebarTabs")} button[title="Statutes"]`,
      waitTimeoutMs: 10000,
      title: "The Statutes tab",
      content: "Click Statutes in the right panel.",
      disableBeacon: true,
      placement: "left",
      advanceOn: { selector: `${sel("editorSidebarTabs")} button[title="Statutes"]`, event: "click" },
      hint: "Click the Statutes tab to continue",
      spotlightClicks: true,
    },
    {
      target: sel("statuteIdentify"),
      waitFor: sel("statuteIdentify"),
      title: "Identify Statutes",
      content:
        "Click this to list the sections your facts support. If the button reads Set Statutes State, click it and choose your state under Include Statutes in Report Preferences first.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("statutesPanel"),
      waitFor: sel("statutesPanel"),
      title: "Read the match strength",
      content:
        "Each result is tagged Strong Match, Match, or Weak Match. A weak match usually means an element is missing from the narrative, not that the charge is wrong.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("statutesPanel"),
      waitFor: sel("statutesPanel"),
      title: "Department sections",
      content:
        "A Dept badge marks a section from your agency's own documents. Click a result to add it to the report, or use Open section (department) or More Info (state) to read the source.",
      disableBeacon: true,
      placement: "left",
    },
  ],
};

export default tour;
